module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAQCAYAAAArij59AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABuSURBVHgBjZFREYAwDEN7KJiESpkj6gAcgAMkIAEJSEACEkp6N/5oWO7eV9Ll1oq7F3ABlUwwV3AIUwSAsYD2VBk45adqBwsLvL+qLFRbqAzCVb6mlVbA2MCcmWNMZ2Y8faeLar2WmVMsKDPpuR/g/4CSXa+KDAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ui/right-arrow.png
// module id = Y6lE
// module chunks = 1